import type { FaireProductEntity } from "../../entity_types/product";

export const p_rurysszbpm: FaireProductEntity = {
  token: "p_rurysszbpm",
  type: "product",
  name: "Today Maybe Tomorrow Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d73946ffaeccd09053d6d49b3c8b1bc9f9b1411c3346b52dcd45ffd14c133480.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b761308d9a84bd98efb85cab70d7adfe4da40126c66c625cdbdc682f44bed103.jpeg",
    "https://cdn.faire.com/fastly/69c432d24927a1a6d7662fe8108365fcc0f68794bb64f3d34d8f9cb98811ef46.jpeg",
  ],
  priceDollars: 9,
  description:
    "Today... or not! Sometimes we use nature as our guide, never rushing yet everything is accomplished. If scrubbing grout is on the to-do list but the sun is out... that one goes to tomorrow!",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:47.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
